export default {
  namespaced: true,
  state: {
    showStatusList: [], // 展示状态枚举
    transactionStatusList: [], // 交易状态枚举
    sourceList: [], // 来源状态枚举
    tagsList: [], // 标签枚举
  },
  getters: {
    showStatusList: state => state.showStatusList,
    transactionStatusList: state => state.transactionStatusList,
    sourceList: state => state.sourceList,
    tagsList: state => state.tagsList
  },
  mutations: {
    showStatusList (state, data) {
      state.showStatusList = data
    },
    transactionStatusList (state, data) {
      state.transactionStatusList = data
    },
    sourceList (state, data) {
      state.sourceList = data
    },
    tagsList (state, data) {
      state.tagsList = data
    },
  },
  actions: {
    showStatusList ({ commit }, data) {
      commit('showStatusList', data)
    },
    transactionStatusList ({ commit }, data) {
      commit('transactionStatusList', data)
    },
    sourceList ({ commit }, data) {
      commit('sourceList', data)
    },
    tagsList ({ commit }, data) {
      commit('tagsList', data)
    },
  }
}
